import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", { for: "checkbox" }, "manu. Gewichtskorrektur", -1)
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", null, [
      _createElementVNode("label", null, [
        _createTextVNode(" Gewünschter Brennwert (kcal): "),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.targetedKilocalories) = $event)),
          type: "number",
          min: "0"
        }, null, 512), [
          [
            _vModelText,
            _ctx.targetedKilocalories,
            void 0,
            { number: true }
          ]
        ])
      ])
    ]),
    _createElementVNode("p", null, [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        id: "checkbox",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.withManualWeightCorrection) = $event))
      }, null, 512), [
        [_vModelCheckbox, _ctx.withManualWeightCorrection]
      ]),
      _hoisted_1
    ]),
    (_ctx.withManualWeightCorrection)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
          _createElementVNode("label", null, [
            _createTextVNode(" Korrektur (g): "),
            (!_ctx.isAndroid)
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.manualWeightCorrection) = $event)),
                  type: "number"
                }, null, 512)), [
                  [
                    _vModelText,
                    _ctx.manualWeightCorrection,
                    void 0,
                    { number: true }
                  ]
                ])
              : _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 1,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.manualWeightCorrection) = $event)),
                  inputmode: "text"
                }, null, 512)), [
                  [
                    _vModelText,
                    _ctx.manualWeightCorrection,
                    void 0,
                    { number: true }
                  ]
                ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("p", null, "Gesamtmasse: " + _toDisplayString(_ctx.overallAmount.toFixed(0)) + "g", 1),
    _createElementVNode("p", null, "Berechn. Portion: " + _toDisplayString(_ctx.calculatedWeight.toFixed(0)) + "g", 1)
  ], 64))
}